import React from 'react';

import theme from 'constants/theme';

import { Typography13 } from 'uiToolkit/Typography';

import { DisableCompetencyContainer, TextButton } from '../common/CompetencyFunctionAndLevelRow';

const DisableCompetencyDescription = ({ onClickHandler, isDisabled = false, isVisible = false }) => {
  if (!isVisible) {
    return null;
  }
  return (
    <DisableCompetencyContainer>
      <Typography13 customColor={theme.palette.text.label}>
        Click <TextButton onClick={onClickHandler}>here</TextButton> to {isDisabled ? 'enable' : 'disable'} this
        description
      </Typography13>
    </DisableCompetencyContainer>
  );
};

export default DisableCompetencyDescription;
